export default {
  ENV: 'prod',
  BASENAME: '',
  PUBLIC_PATH: '/',
  VERSION: '',
  BASE_URL: 'https://api.mozio.com',
  BASE_URL_V2: 'https://api.mozio.com/v2',
  WL_BOOTSTRAP_URL: 'https://www.mozio.com/?staging_api=1&wl=',
}
